const runtimeApiBaseUrl =
  (typeof window !== 'undefined' && window.__API_URL__) ||
  process.env.REACT_APP_API_BASE_URL ||
  '/api';

export const API_BASE_URL = String(runtimeApiBaseUrl).replace(/\/+$/, '');
export const APP_ENVIRONMENT = process.env.REACT_APP_APP_ENV;
export const ACTIVATION_BASE_URL = process.env.REACT_APP_ACTIVATION_BASE_URL;
export const ACTIVATION_API_KEY = process.env.REACT_APP_ACTIVATION_API_KEY;
